import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withPrefix, StaticQuery, graphql } from 'gatsby';

import {
  ChatSupport,
  Header,
  HybridStepper,
  Footer,
  Theme,
  Row,
  Column
} from '@lux/components-gomo';

import {
  LP_SITE_ID,
  LP_SECTION,
  LP_ENGAGEMENT_ID,
  LP_DIV_ID
} from '../../constants/app_configuration';

import burgerImageSrc from '../../assets/images/burger-phone.png';
import burgerSorryImageSrc from '../../assets/images/burger-sorry.png';

const StyledColumn = styled(Column)`
  display: flex;
  justify-content: flex-end;
`;

const StepperColumnContainer = styled.div`
  width: 95%;
  max-width: 460px;
  margin-bottom: 40px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
`;

// padding-bottom for ChatSupport and Footer
const ContentContainer = styled.div`
  padding: 0 ${Theme.spacing.medium};
  padding-bottom: 121px;
`;

const HeaderContainer = styled.div`
  z-index: 0;
`;

export const FooterContainer = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
`;

const MainContentCol = styled(Column)`
  ${Theme.media.md`
    padding: 0 ${Theme.spacing.large};
  `}
`;

export const BurgerImage = styled.img`
  position: relative;
  right: -${Theme.spacing.medium};
  width: 100%;
`;

export const Layout = ({
  data,
  children,
  stepList,
  currentStepIndex,
  hideBurger,
  burgerSorry,
  sendGTM,
  onHeaderLogoClick
}) => {
  return (
    <Container>
      <HeaderContainer>
        <Header
          type="hybrid"
          disableAnimation
          disableLangSelector
          onLogoClick={onHeaderLogoClick}
        />
      </HeaderContainer>
      <ContentContainer>
        <Row>
          <MainContentCol sm={12} lg={hideBurger ? 12 : 5}>
            {currentStepIndex >= 0 && (
              <StepperColumnContainer>
                <HybridStepper
                  stepList={stepList}
                  currentStepIndex={currentStepIndex}
                />
              </StepperColumnContainer>
            )}
            {children}
          </MainContentCol>
          <StyledColumn sm={0} lg={hideBurger ? 0 : 7}>
            <BurgerImage
              src={burgerSorry ? burgerSorryImageSrc : burgerImageSrc}
            />
          </StyledColumn>
        </Row>
      </ContentContainer>
      <FooterContainer>
        <div aria-hidden="true" onClick={sendGTM}>
          <ChatSupport
            secondary
            mdPadding={72}
            lpSiteId={LP_SITE_ID}
            lpSection={LP_SECTION}
            lpEngagementId={LP_ENGAGEMENT_ID}
            lpScripts={{
              config: withPrefix('le-mtagconfig.js'),
              events: withPrefix('LPEvents.js')
            }}
            lpDivId={LP_DIV_ID}
          />
        </div>
        <Footer
          type="hybrid"
          copyrightLiner="© Singtel (CRN: 199201624D). All Rights Reserved."
        />
      </FooterContainer>
      <div
        dangerouslySetInnerHTML={{
          __html: `<!-- v${data.site.siteMetadata.version} -->`
        }}
      />
    </Container>
  );
};

Layout.defaultProps = {
  currentStepIndex: 0
};

Layout.propTypes = {
  /** Elements to be wrapped */
  children: PropTypes.any,
  /** Current step index of HybridStepper */
  currentStepIndex: PropTypes.number,
  /** List of steps */
  stepList: PropTypes.arrayOf(
    PropTypes.shape({
      /** Name to be placed in step circle, preferably a Number */
      name: PropTypes.string,
      /** Unique value of step */
      value: PropTypes.string
    })
  ),
  sendGTM: PropTypes.func,
  /** Handler to get notified when clicked on header logo */
  onHeaderLogoClick: PropTypes.func
};

export default (
  props // eslint-disable-line
) => (
  <StaticQuery
    query={graphql`
      query {
        site {
          siteMetadata {
            title
            version
          }
        }
      }
    `}
    render={data => <Layout data={data} {...props} />}
  />
);
